module.exports = __webpack_public_path__ + "img/02.b90db31b.png";